import React from "react";
import * as styles from "./Stepper.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const Stepper = ({ active, total, className }) => {
	const stepperClassName = classNames({
		[styles["stepper"]]: true,
		[className]: !!className,
	});

	return (
		<div className={stepperClassName}>
			{[...Array(total)].map((item, index) => {
				let classNameItem = classNames({
					[styles["stepper-item"]]: true,
					[styles["stepper-item-active"]]: index < active,
				});
				return <div key={index} className={classNameItem}></div>;
			})}
		</div>
	);
};

Stepper.propTypes = {
	active: PropTypes.number,
	total: PropTypes.number,
};

export default Stepper;
